function generateUID() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g,
    function (c) {
      var r = Math.random() * 16 | 0,
        v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    }).toUpperCase();
}

export function getSessionID() {
  var sessionId = sessionStorage.getItem("vapinghealth_sessionid");
  if (!sessionId || sessionId == "") {
    sessionId = generateUID();
    sessionStorage.setItem("vapinghealth_sessionid", sessionId);
  }
  return sessionId;
}
